import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      localStorage.setItem(
        "logoutReason",
        "Session expired. Please login again.",
      );
      if (
        error.response?.status === 401 &&
        !error.config.url.includes("/admin")
      ) {
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  },
);

export default api;
